import { Paper, Popper } from "@material-ui/core";
import classNames from "classnames";
import React, { useEffect } from "react";

export const PopperWrapper = ({
  id,
  anchorEl,
  onClose,
  onBlurCapture,
  children,
  width = 250,
  side = "right",
  placement = "start",
}: {
  id: string;
  anchorEl: HTMLDivElement | HTMLButtonElement | null;
  onClose: () => void;
  onBlurCapture?: () => void;
  children: React.ReactNode;
  width?: number;
  side?: "left" | "right";
  placement?: "start" | "end";
}) => {
  const [open, setOpen] = React.useState(!!anchorEl);
  const popperRef = React.useRef<any>(null);

  // handle click outside of the button
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const popperNotClicked =
        !popperRef.current || !popperRef.current?.popper?.contains(event?.target);

      if (popperNotClicked) {
        setOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popperRef]);

  useEffect(() => {
    if (!open) {
      onClose();
    }
  }, [open, onClose, anchorEl, onBlurCapture]);

  return (
    <Popper
      id={id}
      open={open}
      anchorEl={anchorEl}
      placement={`${side}-${placement}`}
      transition
      role="dialog"
      popperRef={popperRef}
      className="cw-rounded-xl cw-z-50"
    >
      <Paper className="cw-rounded-xl cw-transition-all cw-z-30">
        <div
          className={classNames(
            `cw-rounded-xl cw-z-50 cw-overflow-auto cw-body-sm cw-bg-default cw-shadow-selectPopup`,
          )}
          style={{ width: `${width}px` }}
        >
          {children}
        </div>
      </Paper>
    </Popper>
  );
};
